"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var icons = _interopRequireWildcard(require("../../toolkit/icons"));

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DefaultSize = 16;

var Checkmark = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Checkmark, _Component);

  var _super = _createSuper(Checkmark);

  function Checkmark() {
    var _this;

    (0, _classCallCheck2["default"])(this, Checkmark);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(Checkmark, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          checked = _this$props.checked,
          className = _this$props.className;
      var iconSrc = icons.greenCheckmark;

      if (!checked) {
        iconSrc = icons.voidNoFill;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root, className)
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: iconSrc,
        className: (0, _styling.css)(this.styles.checkMark),
        draggable: "false"
      }));
    }
  }, {
    key: "styles",
    get: function get() {
      var size = this.props.size;
      var surfaceLightest = this.context.theming.theme.surfaceLightest;
      return _aphrodite.StyleSheet.create({
        root: {
          backgroundColor: surfaceLightest,
          cursor: "default",
          position: "relative",
          flexShrink: 0,
          display: "block",
          width: size ? size : DefaultSize,
          height: size ? size : DefaultSize
        },
        checkMark: {
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: size,
          height: size
        }
      });
    }
  }]);
  return Checkmark;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.demoProps = {
  size: 16,
  checked: true
}, _class3.propDoc = {
  checked: {
    required: true,
    type: "boolean",
    description: "Indicates if the checkmark should show"
  },
  size: {
    required: false,
    type: "number",
    defaultValue: "".concat(DefaultSize),
    description: "Size of the checkmark"
  }
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = Checkmark;
exports["default"] = _default;